import type { ScriptProjectInput } from '@noconflict/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../../shared/api/supabase';
import { getScriptProject, updateScriptProject } from './api';

export const scriptProjectKeys = {
  one: (projectId: string) => ['script-project', projectId] as const,
};

export const useScriptProject = (projectId: string, enabled = true) =>
  useQuery({
    queryKey: scriptProjectKeys.one(projectId),
    queryFn: () => getScriptProject(supabase, projectId),
    enabled,
  });

/** The title names the project, so the project lists are refreshed with the details. */
export function useUpdateScriptProject(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ScriptProjectInput) => updateScriptProject(supabase, projectId, input),
    onSuccess: () =>
      Promise.all([
        qc.invalidateQueries({ queryKey: scriptProjectKeys.one(projectId) }),
        qc.invalidateQueries({ queryKey: ['projects'] }),
      ]),
  });
}
